import { computed } from 'vue';

export function useCarFilterSorting(props, emit) {
  const localSort = computed({
    get: () => props.sort,
    set: value => emit('update:sort', value),
  });

  return {
    localSort
  };
}
